import { render } from "./Lamanform.vue?vue&type=template&id=07028674"
import script from "./Lamanform.vue?vue&type=script&lang=js"
export * from "./Lamanform.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__